import React from "react";
import { Layer } from "thorium-ui";
import { ProjectCard } from "./ProjectCard";

export const ProjectDisplay = (props) => {
   return (
      <Layer className="mx-0 project-display" justify="center">
         {props.projects &&
            props.projects.map((p, key) => (
               <ProjectCard
                  key={key}
                  name={p.name}
                  internalName={p.internal_name}
                  URL={p.URL}
                  github={p.github}
                  thumb={p.thumb}
               />
            ))}
      </Layer>
   );
};

export default ProjectDisplay;
